import Image from '@components/Image';
import { HTMLAttributes } from 'react';

interface Props extends HTMLAttributes<HTMLElement> {
    name: string;
    size?: number;
}

function Icon(props:Props) {
    const { name, size = 24, ...rest } = props;
    return (<Image src={`/icons/ic_${name}.svg`}
        aria-label='icon'
        alt={name}
        width={size}
        height={size}
        {...rest}/>);
}

export default Icon;
